/*
 * Public API Surface of @mmscan/angular-pdf-viewer
 */

export * from './lib/pdf-viewer';
export * from './lib/pdf-viewer-config';
